export const blur = (event, callback) => {
    event.target.blur();
    if (callback) {
        callback();
    }
};
